export default __webpack_public_path__ + "static/media/package-4.a1c7087c.svg";